import { render, staticRenderFns } from "./newsTags.vue?vue&type=template&id=1566274b&scoped=true"
import script from "./newsTags.vue?vue&type=script&lang=js"
export * from "./newsTags.vue?vue&type=script&lang=js"
import style0 from "./newsTags.vue?vue&type=style&index=0&id=1566274b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566274b",
  null
  
)

export default component.exports